export default {
  note: {
    title: 'Særlige ønsker:',
    description: 'Vi gør vores bedste for at imødekomme ønsker, men kan ikke lave ændringer, der påvirker prisen.',
    placeholder: 'Tilføj særligt ønske',
  },
  buttons: {
    add: '+ Tilføj vare',
    update_item: 'Opdater',
    add_to_card: 'Læg i kurv',
  },
  alcohol_warning: 'Dette er en aldersbegrænset vare.',
  caffeine_warning: 'Øget koffeinindhold. Anbefales ikke til børn eller gravide og ammende kvinder.{{value}}',
  error_messages: {
    product_unavailable: 'Udsolgt!',
    item_not_added: 'Varen kunne ikke tilføjes. Prøv igen.',
  },
  success_messages: {
    item_added: 'Varen er tilføjet',
  },
};
